import React, { useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { TimeFilter } from '../filters/TimeFilter';
import {
  Autocomplete,
  Chip,
} from '@mui/material';
import { TextField, Button } from '@mui/material';
import api from '../../../services/api';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import ColorizeIcon from '@mui/icons-material/Colorize';
import LargePopper from '../assets/LargePopper';
import AddIcon from "@mui/icons-material/Add";
import {SlidingPaneAddNew} from "../../Page/SlidingPaneAddNew";

export const CustomFieldForServiceReservationVehicle: FieldComponent<
  any,
  any
> = ({
  onChange,
  isActive,
  value,
  hasTooltip,
  disabled,
  mui,
  column,
  allValue,
  defaultValue,
  title,
}) => {
  const [selectOptions, setSelectOptions] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [openedSlidingPaneAddNew, setOpenedSlidingPaneAddNew] = useState<any>({
    schema: column?.tempSchema,
    row: {},
  });
  const [currentState, setCurrentState] = useState<any>({
    value: null,
    send: false,
  });

  const fetchSelectOptions = async (searchText: string) => {
    setLoading(true);

    const searchParams = new URLSearchParams({
      service_provider_id: allValue?.service_provider?.id,
      service_id: allValue?.service?.id,
    });

    api.get(`/admin/get-vehicle-by-service`, searchParams).then((result: any) => {
      let newObj: any = { name: '(BLANK)' };
      result.unshift(newObj);
      result.unshift({ id: 0, name: '', isButton: true });
      setSelectOptions(result);
      setLoading(false);
    });
  };

  useEffect(() => {
    if (
      typeof defaultValue !== undefined &&
      defaultValue !== null &&
      defaultValue !== undefined
    ) {
      setSelectOptions([defaultValue]);
    }
  }, []);

  useEffect(() => {
    if (defaultValue !== undefined) {
      setCurrentState({
        value: defaultValue,
        send: false,
      });
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      onChange(currentState.value);
    }
  }, [currentState]);

  const handleOnChange = (event: any, value: any) => {
    if (value?.isButton) {
      setOpenedSlidingPaneAddNew({...openedSlidingPaneAddNew, row: allValue});
    } else {
      setCurrentState({
        value: value,
        send: true,
      });
    }
  };

  return (
    <>
      <Autocomplete
        fullWidth={true}
        PopperComponent={LargePopper}
        size="small"
        loading={loading}
        options={selectOptions}
        renderOption={(props: any, option: any) => {
          return (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option?.isButton ? (
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  size={'small'}
                  fullWidth
                >
                  Add new
                </Button>
              ) : (
                <>
                  {(option?.color && typeof option?.color === 'string' && !option?.isButton) ? (
                    <Chip
                      style={{
                        background: `#${option?.color}`,
                        color: '#fff',
                      }}
                      icon={
                        <ColorizeIcon color={'disabled'} sx={{ color: 'white' }} />
                      }
                      label={`#${option.name}`}
                    />
                  ) : (
                    <>{option?.name ? option.name : '-'}</>
                  )}
                </>
              )}
            </Box>
          );
        }}
        getOptionLabel={(option) => (option?.name ? option.name : '-')}
        isOptionEqualToValue={(option, value) => {
          if (!option?.id) return false;
          return option.id === value.id;
        }}
        value={currentState.value}
        onOpen={() => {
          fetchSelectOptions('');
        }}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              size="small"
              label={title}
              InputLabelProps={{
                style: {
                  fontSize: 13,
                  paddingTop: 2,
                },
              }}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          );
        }}
        onChange={(event, newValue) => {
          handleOnChange(event, newValue);
        }}
        disabled={disabled}
      />

      {openedSlidingPaneAddNew?.row?.id && (
        <>
          <SlidingPaneAddNew
            schema={openedSlidingPaneAddNew?.schema}
            id={
              openedSlidingPaneAddNew?.hasOwnPane
                ? undefined
                : openedSlidingPaneAddNew?.row?.id
            }
            onSubmit={() => {
              setOpenedSlidingPaneAddNew({
                schema: column?.tempSchema,
                row: {},
              });
            }}
            propertiesFromTable={
              openedSlidingPaneAddNew?.row ? openedSlidingPaneAddNew?.row : {}
            }
            onClose={(value) => {
              setOpenedSlidingPaneAddNew({
                schema: column?.tempSchema,
                row: {},
              });
            }}
          />
        </>
      )}
    </>
  );
};

CustomFieldForServiceReservationVehicle.includes = (query, value) => true;

CustomFieldForServiceReservationVehicle.comparator = () => 0;

CustomFieldForServiceReservationVehicle.FilterRenderer = TimeFilter;
